const ERROR_COPY_KEYS = new Map<string, string>(
  Object.entries({
    publish_failed: 'inbox.error.publish_failed',
    publish_partial: 'inbox.error.publish_partial',
    linkedin_account_not_connected: 'inbox.error.linkedin_account_not_connected',
    design_page_render_missing: 'inbox.error.design_page_render_missing',
    unexpected_error: 'inbox.error.unexpected_error',
    article_health_check_failed: 'inbox.error.article_health_check_failed',
    token_revoked: 'inbox.error.token_revoked',
    brand_style_enqueue_failed: 'inbox.error.brand_style_enqueue_failed',
    brand_style_failed: 'inbox.error.brand_style_failed',
    brand_style_rejected: 'inbox.error.brand_style_rejected',
    run_timed_out: 'inbox.error.run_timed_out',
  }),
)

const FALLBACK_KEY = 'inbox.error.unknown'

/** The message key for a publishing or account error code; the fallback key for a code with no copy of its own. */
export function errorCopyKey(code: string | null | undefined): string {
  return (code ? ERROR_COPY_KEYS.get((code.split(':')[0] ?? '').trim()) : undefined) ?? FALLBACK_KEY
}
